<template>
  <div>
    <div class="login-container" style="padding-bottom: 10%">
      <slot/>
    </div>

    <div class="container" style="margin-bottom: 60px">
      <div class="row">
        <div class="col-lg-12 text-center">
          <div style="color:#aaa;margin-bottom: 10px;">{{ $t('Service operator') }}</div>
          <a href="https://konversta.com">
            <img src="../../public/img/konversta.png" alt style="width: 150px;">
          </a>
          <div style="color:#aaa;margin-top: 10px;">
            {{ $t('By continuing to use the site, you consent to the processing of cookies') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import viewTranslationMixin from '@/mixins/viewTranslationMixin'

export default {
  name: 'LoginLayout',

  mixins: [
    viewTranslationMixin
  ],

  metaInfo () {
    const headTitle = this.$t('Head title') ?? 'Конверста – Вход в Қазақстан су жолдары (КСЖ)'

    return {
      title: headTitle
    }
  },

  created () {
    this.getTranslations()
  }
}
</script>
